import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChartViewIcon, TableViewIcon } from '../../../../../../../styles';
import { StyledIconButton } from './shared-styles';

interface TableViewToggleProps {
  showTableView: boolean;
  onClick: () => void;
}

export const TableViewToggle = (props: TableViewToggleProps) => {
  const { showTableView, onClick } = props;
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Tooltip
      title={
        showTableView
          ? t('common:commonValues.tooltips.toggleChartView')
          : t('common:commonValues.tooltips.toggleDataView')
      }
      placement="top"
    >
      <StyledIconButton
        onClick={handleClick}
        size="small"
        aria-label={showTableView ? 'Chart View' : 'Table View'}
      >
        {showTableView ? (
          <ChartViewIcon className="intercom_toggle_chart_view" />
        ) : (
          <TableViewIcon className="intercom_toggle_table_view" />
        )}
      </StyledIconButton>
    </Tooltip>
  );
};
